import { render } from "./Kiosk.vue?vue&type=template&id=17ab3ac4"
import script from "./Kiosk.vue?vue&type=script&lang=js"
export * from "./Kiosk.vue?vue&type=script&lang=js"

import "./Kiosk.vue?vue&type=style&index=0&id=17ab3ac4&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__